import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { NotifFromGrafferListPage } from "./list";
import { useHistory } from "react-router";
import { SettingR } from "../route";
import {
  GrafferNotifService,
  NotifFetchLimit,
} from "../../../../application/domain/notifi-from-graffer/notif-from-graffer-service";
import {
  parseQueryOfLocation,
  rebuildQuery,
} from "../../../../utils/url-utils";
import { useLocation } from "react-router-dom";
import { toTotalPage } from "../../../../application/domain/pagination/paging";
import { NotifFromGrafferType } from "../../../../application/domain/notifi-from-graffer/notif-from-graffer";

export const NotifFromGrafferPage: React.FC = () => {
  const history = useHistory();
  const p = Number(parseQueryOfLocation(useLocation()).page);
  const pageNum = Number.isInteger(p) && p > 0 ? p : 1;

  const [notifs, setNotifs] = useState<NotifFromGrafferType[]>([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const movePage = useCallback(
    (p: number) => {
      history.push(
        rebuildQuery({
          page: p.toString(),
        }),
      );
    },
    [history],
  );

  const fetchNotifications = useCallback(
    async (p: number) => {
      setIsLoading(true);
      const fetched = await GrafferNotifService.fetchPage(p);
      setNotifs(fetched[0]);
      setTotal(toTotalPage(fetched[1], NotifFetchLimit));
      setIsLoading(false);
    },
    [setNotifs, setTotal],
  );

  useEffect(() => {
    fetchNotifications(pageNum);
    GrafferNotifService.updateLastCheckedAt();
  }, [fetchNotifications, pageNum]);

  return (
    <NotifFromGrafferListPage
      list={notifs}
      onSelected={(selected) => {
        history.push(SettingR.NotifFromGrafferDetail.link(selected.slug));
      }}
      movePage={movePage}
      paging={{ current: pageNum, total: total }}
      isLoading={isLoading}
    />
  );
};

export const NotifFromGrafferContainer = NotifFromGrafferPage;
